<template>
  <div class="message-wrapper w-100" :class="{own:note.created_by.practice_id == user.practice.id, system: note.type === 'SYSTEM' }">
    <div class="who" v-if="note.type==='CUSTOM' && showUser">
      <small class="text-hint">{{note.created_by.id == user.id ? 'You' : $helpers.displayUsername(note.created_by)}}</small>
    </div>
    <div class="message d-inline-block" :class="{'mt-2': note.type === 'SYSTEM', 'mt-1': !showUser}">
      {{note.details}}
    </div>
    <slot>
    </slot>
    <!-- <div v-if="note.type === 'SYSTEM'" class="text-center" :key="date">
      <small class="text-muted">{{date}}</small>
    </div> -->
    <!-- <div class="col-2"><b class="text-nowrap"></b></div>
    <div class="col">
      <div v-if="note.type == 'CUSTOM'" class="d-flex justify-content-between px-3 py-2 border rounded">
        <div class="">
          <span class="text-muted mr-2">Comment</span>
          <b>{{note.details}}</b>
        </div>
        <span class="text-muted">{{moment(note.created_at).format('lll')}}</span>
      </div>
      <div class="d-flex justify-content-between px-3 py-2" v-else>
        <div><span class="text-muted">{{note.details}}</span> <b v-if="meta" class="ml-2">{{meta}}</b></div>
        <span class="text-muted">{{moment(note.created_at).format('lll')}}</span>
      </div>
    </div> -->
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
export default {
  props: {
    note: {
      type: Object,
      required: true,
    },
    referral: {
      type: Object,
      required: true,
    },
    showUser: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      yesterday: moment().subtract(1, 'days'),
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    meta() {
      if (this.note.meta) {
        if (this.note.details == 'File Uploaded') {
          let attachment = this.referral.attachments.find(
            (s) => s.id == this.note.meta
          )
          return attachment?.custom_name || attachment?.name
        }
      }
    },
    date() {
      const mo = moment(this.note.created_at)

      return mo.isAfter(this.yesterday) ? mo.fromNow() : mo.format('lll')
    },
  },
}
</script>

<style lang="scss" scoped>
.message-wrapper {
  .message {
    padding: 0.5rem 1rem;
    border-radius: 4px;
    background: var(--light-color);
    margin-right: 4rem;
    margin-left: 0;
    word-break: break-word;
  }

  &.own {
    text-align: right;
    .who {
      display: none;
    }
    .message {
      background: var(--primary-color);
      color: #fff;
      margin-right: 0;
      margin-left: 4rem;
      margin-top: 0.5rem;
    }
  }

  &.system {
    text-align: center;
    .message {
      margin: 0 auto;
      background: var(--info-color);
      font-style: italic;
      background: rgba(239, 123, 58, 0.2);
      color: var(--body-color);
    }
  }
}
</style>